import styled from 'styled-components';
import { getScreenMaxHeight, getScreenMaxWidth } from '../../utils/bundle.esm3.js';

const TabsMenuStyled = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  isolation: isolate;

  .TabsMenu {
    &__page {
      flex: 1;
      display: flex;
      flex-direction: column;
      min-height: ${getScreenMaxHeight()};

      & > *:last-child {
        padding-bottom: ${(props) => props.barHeight}px;
      }
    }

    &__bar {
      background-color: #fff;
      box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.1);
      bottom: 0;
      left: 0;
      position: fixed;
      width: ${getScreenMaxWidth()};
      z-index: 4;
    }

    &__tabs {
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      padding: 0.8rem 0;

      &__item {
        list-style: none;
        cursor: pointer;
      }
    }
  }
`;

export { TabsMenuStyled as default };
//# sourceMappingURL=bundle.esm2.js.map
